import {React} from 'common'
import IconButton from '@mui/material/IconButton'
import {useGetProfileQuery} from 'store/Store.js'
import {Avatar} from '@mui/material'
import VerifiedChip from 'components/Control/Chip/VerifiedChip'

const HeaderActions = ({menuId, handleProfileMenuOpen, isChoreographer}) => {
    const {data: user} = useGetProfileQuery()

    return (
        <IconButton
            size="large"
            edge="end"
            aria-label="account of current user"
            aria-controls={menuId}
            aria-haspopup="true"
            onClick={handleProfileMenuOpen}
            color="inherit">
            <Avatar
                src={user?.profileImageUrl || ''}
                sx={{height: 50, width: 50}}
            />
            {isChoreographer && <VerifiedChip />}
        </IconButton>
    )
}

export default HeaderActions
